import { formatCount } from '@/lib/format'

import styles from './ConcentrationPanel.module.css'

interface ConcentrationPanelProps {
  concentrationPct: number
  vendorCount: number
  txnCount: number
  departmentCount: number
  quarterShort: string
}

export function ConcentrationPanel({
  concentrationPct,
  vendorCount,
  txnCount,
  departmentCount,
  quarterShort,
}: ConcentrationPanelProps) {
  return (
    <div className={styles.wrap}>
      <div className={`${styles.big} num`}>{concentrationPct}%</div>
      <div className={styles.sub}>
        of all {quarterShort} expense dollars went to just the <b>top 10 vendors</b>
      </div>
      <dl className={styles.stats}>
        <div>
          <dt>distinct vendors</dt>
          <dd className="num">{formatCount(vendorCount)}</dd>
        </div>
        <div>
          <dt>transactions</dt>
          <dd className="num">{formatCount(txnCount)}</dd>
        </div>
        <div>
          <dt>departments</dt>
          <dd className="num">{formatCount(departmentCount)}</dd>
        </div>
      </dl>
    </div>
  )
}
